import { render, staticRenderFns } from "./DtCostumersTOperador.vue?vue&type=template&id=6c16cc4a"
import script from "./DtCostumersTOperador.vue?vue&type=script&lang=js"
export * from "./DtCostumersTOperador.vue?vue&type=script&lang=js"
import style0 from "./DtCostumersTOperador.vue?vue&type=style&index=0&id=6c16cc4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports